import { memo } from 'react'
import { useSwiper } from 'swiper/react'

import { CarouselButtonIcon } from '../Icons'

const NextButton: React.FC = memo(() => {
  const swiper = useSwiper()
  const swipeNext = () => {
    if (swiper.animating) return
    swiper.slideNext()
  }
  return (
    <button
      className="tc-mv-carousel-nav-button text-white z-10 absolute top-[calc(50%-48px)] -translate-y-1/2 right-[24px]"
      onClick={swipeNext}
    >
      <CarouselButtonIcon />
    </button>
  )
})

const PrevButton: React.FC = memo(() => {
  const swiper = useSwiper()
  const swipePrev = () => {
    if (swiper.animating) return
    swiper.slidePrev()
  }
  return (
    <button
      className="tc-mv-carousel-nav-button text-white z-10 absolute top-[calc(50%-48px)] -translate-y-1/2 left-[24px] rotate-180 mr-5"
      onClick={swipePrev}
    >
      <CarouselButtonIcon />
    </button>
  )
})

export { NextButton, PrevButton }
